import { Box, Divider } from "@mui/material";

import { User } from "../../../../../types/types/user.types";

import About from "../../../components/About";
import Overview from "../../../components/OverView";
import EndorsedSkills from "../../../components/EndorsedSkills";
import Trophies from "../../../components/Trophies";
import Experience from "../../../components/Experience";
import Testimonials from "../../../components/Testimonials";
import CountriesCareer from "../../../components/CountriesCareer";

interface HomeTabProps {
  profile?: User;
  isLoading: boolean;
}

const HomeTab = ({ profile, isLoading }: HomeTabProps) => {
  return (
    <Box sx={{ display: "flex", flexDirection: "column", gap: "16px" }}>
      <About about={profile?.bio} isLoading={isLoading} />
      <Box
        sx={{
          display: "flex",
          flexDirection: "column",
          gap: "16px",
          borderRadius: "8px",
          border: "1px solid #EAECF0",
          background: "#FFF",
          padding: "20px",
        }}
      >
        <Overview overViewTitle="agentOverview" overViewList={profile?.overview} isLoading={isLoading} />
        <Divider orientation="horizontal" flexItem sx={{ backgroundColor: "var(--gray-200, #EAECF0)" }} />
        <CountriesCareer countries={profile?.countriesWorkedIn} isLoading={isLoading} />
      </Box>
      <EndorsedSkills />
      <Experience />
      <Trophies />
      <Testimonials />
    </Box>
  );
};

export default HomeTab;
